import { render, staticRenderFns } from "./PreCargaContainer.vue?vue&type=template&id=cafd8606&scoped=true"
import script from "./PreCargaContainer.vue?vue&type=script&lang=js"
export * from "./PreCargaContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafd8606",
  null
  
)

export default component.exports